import { render } from "./NavHeart.vue?vue&type=template&id=04434e23&scoped=true"
const script = {}

import "./NavHeart.vue?vue&type=style&index=0&id=04434e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04434e23"]])

export default __exports__